<template>
  <div>
  <div class="page-login__content">Please enter your email address to verify access.</div>
    <form @submit.prevent="authorize">
      <div class="row page-login__sign-in-row">
        <div class="page-login__input col-md-3"></div>
        <div class="page-login__input col-md-6">
          <input
              class="page-login__login-input list-group-item form-control"
              type="text"
              v-model="email"
              placeholder="email" />
        </div>
        <div class="page-login__input col-md-3"></div>
      </div>
      <div class="row text-center">
        <div class="col">
          <button class="page-login__login-btn" type="submit" :disabled="!isFormValid">Authorize</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'AuthorizeForm',
    mounted() {
      if (!this.$store.getters['auth/access_code']) {
        this.$store.dispatch('auth/setProperty', { key: 'access_code', value: localStorage.getItem('access_code') });
      }
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
    data() {
      return {
        email: '',
        loading: false,
      };
    },
    watch: {
      loading() {
        this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: this.loading });
      },
    },
    computed: {
      isEmailValid() {
        return (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/.test(this.email));
      },
      isFormValid() {
        return this.isEmailValid;
      },
    },
    methods: {
      authorize() {
        this.loading = true;
        this.$store.dispatch('auth/authorizeMeetingAccess', this.email)
          .then((data) => {
            this.$router.push({ name: 'meeting-agenda', params: { id: data } })
          })
          .catch(() => {
            this.loading = false;
            this.error = true;
          })
      },
    },
  };
</script>
